var $ = require('jquery');
require('bootstrap');
require('lavalamp');
require('jquery-countto');
var OnScreen = require('onscreen');
var os = new OnScreen({
    tolerance: 0,
    debounce: 100
});

$(function() {

    //Resize logo on scroll
    /*
    window.onscroll = function() {
        resizeLogo()
    };

    function resizeLogo() {
        var Logo = document.getElementById("logo")
        if (document.body.scrollTop > 5 || document.documentElement.scrollTop > 5) {
            Logo.style.width = '200px';
        } else {
            Logo.style.width = '325px';
        }
    }
    */









//Enlarge left
    $('.enlarge-l').each(function () {
        var thiswidth = $(this).width();
        var thisml = parseInt($(this).css('marginLeft'));
        var thismr = parseInt($(this).css('marginRight'));
        if(thisml > 0){
            thisml = 0;
        }
        if(thismr > 0){
            thismr = 0;
        }
        var thism=-thismr-thisml;
        var width = document.querySelector('#content > .container').clientWidth;
        var fullwidth = $(document).width();
        $(this).css({
            marginLeft: (width-fullwidth)/2,
            width: 'calc( ' + String((100/(width/thiswidth))) + '% + ' + String(((fullwidth-width)/2)+thism) + 'px )',
            maxWidth: 'unset'
        });
    });
//Enlarge right
    $('.enlarge-r').each(function () {
        var thiswidth = $(this).width();
        var thisml = parseInt($(this).css('marginLeft'));
        var thismr = parseInt($(this).css('marginRight'));
        if(thisml > 0){
            thisml = 0;
        }
        if(thismr > 0){
            thismr = 0;
        }
        var thism=-thismr-thisml;
        var width = document.querySelector('#content > .container').clientWidth;
        var fullwidth = $(document).width();
        $(this).css({
            marginRight: (width-fullwidth)/2,
            width: 'calc( ' + String((100/(width/thiswidth))) + '% + ' + String(((fullwidth-width)/2)+thism) + 'px )',
            maxWidth: 'unset'
        });
    });
    window.onresize = function(event) {
        //Enlarge left
        $('.enlarge-l').each(function () {
            $(this).removeAttr("style");
            var thiswidth = $(this).width();
            var thisml = parseInt($(this).css('marginLeft'));
            var thismr = parseInt($(this).css('marginRight'));
            if(thisml > 0){
                thisml = 0;
            }
            if(thismr > 0){
                thismr = 0;
            }
            var thism=-thismr-thisml;
            var width = document.querySelector('#content > .container').clientWidth;
            var fullwidth = $(document).width();
            $(this).css({
                marginLeft: (width-fullwidth)/2,
                width: 'calc( ' + String((100/(width/thiswidth))) + '% + ' + String(((fullwidth-width)/2)+thism) + 'px )',
                maxWidth: 'unset'
            });
        });
        //Enlarge right
        $('.enlarge-r').each(function () {
            $(this).removeAttr("style");
            var thiswidth = $(this).width();
            var thisml = parseInt($(this).css('marginLeft'));
            var thismr = parseInt($(this).css('marginRight'));
            if(thisml > 0){
                thisml = 0;
            }
            if(thismr > 0){
                thismr = 0;
            }
            var thism=-thismr-thisml;
            var width = document.querySelector('#content > .container').clientWidth;
            var fullwidth = $(document).width();
            $(this).css({
                marginRight: (width-fullwidth)/2,
                width: 'calc( ' + String((100/(width/thiswidth))) + '% + ' + String(((fullwidth-width)/2)+thism) + 'px )',
                maxWidth: 'unset'
            });
        });
    };









//Lavalamp menu

    $('#main-navbar ul.navbar-nav').lavalamp({
        easing: 'easeOutBack',
        activeObj: '[class*="current-page-"],[class*="current-menu-"]'
    });
    $(window).on('resizeEnd', function () {
        $('#main-navbar ul.navbar-nav').lavalamp('update');
    });


//AddSticky Class on scroll

    function stickyHeader() {
        var StickyHeader = $("#header")
        if (document.body.scrollTop > 5 || document.documentElement.scrollTop > 5) {
            StickyHeader.addClass('sticky');
        } else {
            StickyHeader.removeClass('sticky');
        }
    }

    //Add action on scroll
    window.onscroll = function() {
        stickyHeader();
    };


    //Counter

    $('.count').each(function () {
        var totalcount = Number($(this).html());
        $(this)
            .html('0')
            .data('count',totalcount)
            .data('counted',false);
    });
    os.on('enter', '.count', function(element, event){
        if( !Boolean($(element).data('counted')) ) {
            $(element)
                .countTo({
                    from: 0,
                    to: Number($(element).data('count')),
                    speed: 1500
                })
                .data('counted', true);
        }
    });

});